import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiCompanyService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgActionType
    ,PagingInfo
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.etas.car.form.component.html"
    ,providers: []
})
export class DtgManageEtasCarFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    @Input() dtgEid:string;
    @Input() dtgUnitId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
     }

    ngOnInit() {
        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.getListEtasCar();
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.getListEtasCar();
                this.formGroup.disable();
                break;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            dtgEid:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgUnitId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,useYn:"N"
            ,lastUpDt:null
        });
    }

    get f() { return this.formGroup.controls; }

    getListEtasCar(){
        let searchInfo = {
            dtgEid : this.dtgEid
            ,dtgUnitId : this.dtgUnitId
        };
        this.fvmsApiCompanyService.findAllEtasCarPaging(searchInfo,new PagingInfo())
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue) {
                        let etasCar = apiResponse.resultValue[0];
                        this.formGroup.patchValue(etasCar);
                    }
                }
            });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f.lastUpDt.value);
        if (this.formGroup.invalid) {
            return;
        }

        let userInfo = {
            dtgEid:this.f.dtgEid.value
            ,dtgUnitId:this.f.dtgUnitId.value
            ,useYn:this.f.useYn.value
            ,lastUpDt:this.f.lastUpDt.value
        };
        // console.log("onSubmit",userInfo);

        this.fvmsApiCompanyService.upsertEtasCar(userInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    console.log("upsert id",apiResponse.resultValue.dtgUnitId);
                }

                this.activeModal.close({
                    "result":"ok"
                });
            });
        return;
    }
}